import React from 'react';

const MarketPanelVolumeShockers = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Volume Shockers</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="volume-shockers">
            <thead>
              <tr>
                <th>Stock Name</th>
                <th>Current Price</th>
                <th>Change</th>
                <th>% Change</th>
                <th>Volume</th>
                <th>Value (₹ Lakhs)</th>
                <th>High</th>
                <th>Low</th>
                <th>Prev. Close</th>
                <th>Open</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.stock_name || '-'}</td>
                    <td>{item.current_price || '-'}</td>
                    <td>{item.change || '-'}</td>
                    <td>{item.percent_change || '-'}</td>
                    <td>{item.volume || '-'}</td>
                    <td>{item.value || '-'}</td>
                    <td>{item.high || '-'}</td>
                    <td>{item.low || '-'}</td>
                    <td>{item.prev_close || '-'}</td>
                    <td>{item.open || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelVolumeShockers; 